import { gql } from 'apollo-angular';

export const RemoveTacticDocument = gql(/* GraphQL*/ `mutation removeTactic($id: Int!) {
  removeTactic(id: $id)
}
`);
